export enum Account {
  Any = '*',
  Aws = 'aws',
  Undefined = '',
}
export enum Region {
  Any = '*',
  Global = 'us-east-1',
  Undefined = '',
  Tokyo = 'ap-northeast-1',
  Seoul = 'ap-northeast-2',
  Osaka = 'ap-northeast-3',
  Mumbai = 'ap-south-1',
  Singapore = 'ap-southeast-1',
  Sydney = 'ap-southeast-2',
  Central = 'ca-central-1',
  Frankfurt = 'eu-central-1',
  Stockholm = 'eu-north-1',
  Ireland = 'eu-west-1',
  London = 'eu-west-2',
  Paris = 'eu-west-3',
  Sao_Paulo = 'sa-east-1',
  N_Virginia = 'us-east-1',
  Ohio = 'us-east-2',
  N_California = 'us-west-1',
  Oregon = 'us-west-2',
}

export const ArrayRegions = [
  'ap-northeast-1',
  'ap-northeast-2',
  'ap-northeast-3',
  'ap-south-1',
  'ap-southeast-1',
  'ap-southeast-2',
  'ca-central-1',
  'eu-central-1',
  'eu-north-1',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'sa-east-1',
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
];
